
import { createDrawerNavigator, } from "@react-navigation/drawer";
import Tabnavigator from "./TabBar";
import DrawerCustom from '../DrawerCustom'
import DetailEvent1 from "../Screen/Event/DetailEvent";
import Event from "../Screen/Event/Event";
import Ionicons from 'react-native-vector-icons/Ionicons'
import { useWindowDimensions } from "react-native-web";
import PgMaker from "../Screen/PgMaker/PgMaker";
import DetailSheet from "../Screen/CharacterManagment/DetailSheet";
import Interlude from "../Screen/PgMaker/Interlude";
import PgModify from "../Screen/PgMaker/PgModify";
import Download1 from "../Screen/Home/Download1";
import PgList from "../Screen/Master/pgList";
import { useEffect, useState } from "react";
import { db } from '../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../firebase/FirebaseConfig';
import { useNavigation } from '@react-navigation/native'

const Drawer= createDrawerNavigator();

const AppDrawer= props =>{
const windows=useWindowDimensions()
const navigation=useNavigation()


    const [flip, setFlip]=useState(false)

    const user= auth.currentUser

useEffect(()=>{
    
        kimera()
      
},[])
  
async function kimera(){
    
    let png=[]
    let information=query(collection(db,"utenti"),where("email","==",user.email), where("master","==",true));
    let querySnapshot= await getDocs(information);
          querySnapshot.forEach((docs)=>{png.push(docs.data());});
          if(png[0]==undefined){setFlip(false)}
          else{setFlip(true)}
          setTimeout(5000)
}
    




  

    return(
        
        

        <Drawer.Navigator drawerContent={props =><DrawerCustom {... props}/>} 
        screenOptions={{drawerStyle:{backgroundColor:'#303030',}, drawerInactiveBackgroundColor:'#303030',drawerActiveBackgroundColor:'#F9BA47', drawerActiveTintColor:'#191919', drawerInactiveTintColor:'#7c7d7e' ,drawerLabelStyle: {marginLeft:-25, fontSize:15}, headerTintColor:'#F9BA49', headerStyle:{backgroundColor:'#303030', borderBottomColor:'#F9BA49',  height:60, }, headerTitle:'', headerStatusBarColor:'#F9BA49',
        headerShown:false,
        sceneContainerStyle:{width:windows.width, height:windows.height , alignSelf:'center'},
        shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:5, shadowOffset:{width:5, height:5}}}>
           
            <Drawer.Screen name='Home' component={Tabnavigator} options={{drawerIcon: ({color})=>(<Ionicons name="home-outline" size={22} color={color}/>), headerShown:true,}}/>
            <Drawer.Screen name='Download' component={Download1} options={{drawerIcon: ({color})=>(<Ionicons name="download-outline" size={22} color={color}/>), headerShown:true,}}/>
            {flip?  <Drawer.Screen name='Lista Personaggi' component={PgList} options={{drawerIcon: ({color})=>(<Ionicons name="download-outline" size={22} color={color}/>), headerShown:true,}}/>:<></>}
            <Drawer.Screen name='Event' component={Event}  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
            <Drawer.Screen name='DetailEvent' component={ DetailEvent1 }  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
            <Drawer.Screen name='PgMaker' component={PgMaker}  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
            <Drawer.Screen name='PgModify' component={PgModify}  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
            <Drawer.Screen name='DetailSheet' component={DetailSheet}  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
            <Drawer.Screen name='Interlude' component={Interlude}  options={{drawerItemStyle:{display:'none',}}} screenOptions={{headerShown:false}} />
        </Drawer.Navigator>
        

    )}

export default AppDrawer;